module.exports = __webpack_public_path__ + "img/rounded_red_close.eb4e2790.svg";